import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthProvider";
import { map } from "lodash";
import { fetchWithInterceptor } from "../utils/fetchWithInterceptor";

export default function useSubgroups(refresh) {
  const authContext = useContext(AuthContext);

  const [subgroups, setSubgroups] = useState([]);

  const getSubgroups = async () => {
    const response = await fetchWithInterceptor(
      `/api/integrations/liquor-connect/subgroups`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": authContext.getToken(),
        },
      }
    );
    if (response.ok) {
      const data = await response.json();
      setSubgroups(map(data, (subgroup) => ({ label: subgroup.name, value: subgroup.name, groupName: subgroup?.group?.name })))
    }
  };

  useEffect(() => {
    getSubgroups();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh])

  return subgroups;
}